import styled, { keyframes } from 'styled-components'
import { rollOut } from 'react-animations'

import { colors } from '../../../module/colors'
import { size_2, size_4, text_base } from '../../../module/style-variables'

const animateButton = keyframes`${rollOut}`

export const Button = styled.button`
  border: none;
  padding: ${props => (props.large ? `${size_4}` : `${size_2}`)};
  text-transform: uppercase;
  cursor: pointer;
  outline: none;
  transition: all 0.2s ease;
  width: ${props => (props.fullWidth ? '100%' : '')};
  animation: ${props => (props.animateOnClick && props.clicked ? `0.4s ${animateButton}` : '')};
  ${text_base};
  ${props => {
    const { buttons } = colors
    const { main, alternative } = buttons
    if (props.type === 'main') {
      return `
          background: ${main.color};
          color: ${main.text};
          &:hover {
            background: ${main.hoverColor};
            color: ${main.hoverText};
          }          
        `
    }
    if (props.type === 'alternative') {
      return `
        background: ${alternative.color};
        color: ${alternative.text};
        &:hover {
          background: ${alternative.hoverColor};
          color: ${alternative.hoverText};
        }          
        `
    }
  }};
`



// WEBPACK FOOTER //
// ./src/component/_presentational/Button/Button-styled.js